// extracted by mini-css-extract-plugin
module.exports = {"cell":"_2TfM08","row":"_3c4YXL","cellActive":"fvQ1EV","cellSelected":"_19NezL","success":"_3DG2TK","failure":"_2trTpV"};